
var IBAN = require('iban');

export const phonePrefixes = ['12','13','14','15','16','17','18','22','23','24','25','29','32','33','34','41','42','43','44','46','48','52','54','55','56','58','59','61','62','63','65','67','68','71','74','75','76','77','81','82','83','84','85','86','87','89','91','94','95']


export const isPatternValid = (pattern, value) => {
  let output = true;
  if (pattern) {
    switch (pattern) {
        case 'NIP':
            output = validateNip(value);
            break;
        case 'PESEL':
            output = isValidPesel(value);
            break;
        case 'IBAN':
            output = IBAN.isValid(value.replace(/ /g, ''));
            break;
        case 'LIMIT':
            output = parseInt(value) <= 100000 && parseInt(value) >= 1000;
            break;
        case 'MIN':
            output = parseInt(value) >= 100;
            break;
        case 'CARDS':
            output = parseInt(value) <= 200 && parseInt(value) >= 1;
            break;
        case 'PHONE':
            const phoneReg = new RegExp('\\d{11}');
            const stripedValue = value.match(/.{1,2}/g);
            output = stripedValue && phoneReg.test(value) && stripedValue[0] == '48' && phonePrefixes.indexOf(stripedValue[1]) == -1;
            break;
        default:
            const reg = new RegExp(pattern);
            output = reg.test(value);
            break;
    }
  }

  return output;
}

export const validateNip = (nip) => {
  if (!nip) return false;
  let nipWithoutDashes = nip.replace(/-/g, '');
  const reg = /^[0-9]{10}$/;
  if (reg.test(nipWithoutDashes) === false) {
    return false;
  } else {
    let digits = ('' + nipWithoutDashes).split('');
    let checksum =
      (6 * parseInt(digits[0]) +
        5 * parseInt(digits[1]) +
        7 * parseInt(digits[2]) +
        2 * parseInt(digits[3]) +
        3 * parseInt(digits[4]) +
        4 * parseInt(digits[5]) +
        5 * parseInt(digits[6]) +
        6 * parseInt(digits[7]) +
        7 * parseInt(digits[8])) %
      11;
    return parseInt(digits[9]) === checksum;
  }
};

export const isValidPesel = (pesel) => {
  if(typeof pesel !== 'string')
      return false;

  let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  let sum = 0;
  let controlNumber = parseInt(pesel.substring(10, 11));

  for (let i = 0; i < weight.length; i++) {
      sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
  }
  sum = sum % 10;
  return (10 - sum) % 10 === controlNumber;
}